import { useEffect, useState } from 'react';

import { Box, Button, Dialog, Input, useToast } from '@aicon-dev/caas-ui';
import { useMutation } from '@tanstack/react-query';

import { useCatch } from '~/libs/hooks/useCatch';
import { deleteAccount } from '~/modules/auth/libs/apis';

import { useAuthContext } from '../../../../auth/context/AuthProvider';
import { deleteAccountButton } from '../libs/styles.css';

export const UserFormDelete = () => {
  const { userInfo } = useAuthContext();
  const [open, setOpen] = useState(false);

  /**
   * 회사에 소속되지 않은 사용자만 회원탈퇴 가능
   */
  if (userInfo?.company?.company_id) return null;

  return (
    <>
      <button type="button" className={deleteAccountButton} onClick={() => setOpen(true)}>
        회원탈퇴
      </button>
      <DeleteDialog open={open} onClose={() => setOpen(false)} />
    </>
  );
};

interface DeleteDialogProps {
  open?: boolean;
  onClose?: () => void;
}
const DeleteDialog = (props: DeleteDialogProps) => {
  const { open, onClose } = props;
  const { logout } = useAuthContext();
  const { catchError } = useCatch();
  const toast = useToast();
  const [inputValue, setInputValue] = useState('');

  useEffect(() => {
    setInputValue('');
  }, [open]);

  const { mutate, isPending } = useMutation({
    mutationFn: async () => {
      await deleteAccount();
    },
    onSuccess() {
      logout();
      toast.normal('계정이 정상적으로 삭제되었습니다. 이용해주셔서 감사합니다.');
    },
    onError(error) {
      catchError(error);
    },
  });

  return (
    <Dialog
      open={open}
      onClose={onClose}
      title="회원탈퇴하면 데이터를 복구 할 수 없습니다. 탈퇴를 원하시면 아래 ‘탈퇴’라고 입력해주세요."
      style={{ maxWidth: 340 }}
      footer={
        <>
          <Button onClick={onClose} style={{ minWidth: 100 }}>
            취소
          </Button>
          <Button
            color="danger"
            variant="filled"
            onClick={() => {
              if (inputValue === '탈퇴') {
                mutate();
              } else {
                toast.error('탈퇴를 원하시면 아래 ‘탈퇴’라고 입력해주세요.');
              }
            }}
            style={{ minWidth: 100 }}
            loading={isPending}
          >
            탈퇴
          </Button>
        </>
      }
    >
      <Box px="24" pb="16">
        <Input
          block
          size="large"
          placeholder="탈퇴"
          value={inputValue}
          onChange={(e) => setInputValue(e.target.value)}
        />
      </Box>
    </Dialog>
  );
};
